import { apiGet } from '@/lib/http/client';

import type { ActiveCampaignSyncHealthResponse } from '../types';

export async function getActiveCampaignSyncHealth(
  orgId: number | string
): Promise<ActiveCampaignSyncHealthResponse> {
  return apiGet<ActiveCampaignSyncHealthResponse>(
    `/api/orgs/${orgId}/activecampaign/sync-health/`
  );
}
